import { render, staticRenderFns } from "./AuctionPauseMessage.vue?vue&type=template&id=368f5454&scoped=true"
import script from "./AuctionPauseMessage.vue?vue&type=script&lang=js"
export * from "./AuctionPauseMessage.vue?vue&type=script&lang=js"
import style0 from "./AuctionPauseMessage.vue?vue&type=style&index=0&id=368f5454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f5454",
  null
  
)

export default component.exports